import React from "react";
import styled from "styled-components";
import { Box, Typography } from "@mui/material";

const Row = styled(Box)`
  background: ${(props) => (props.index % 2 === 0 ? "#232323" : "#2f2f2f")};
`;

const Label = styled(Typography)`
  &.MuiTypography-root {
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
    color: #a0a0a0;
    font-family: "Open Sans", sans-serif;
  }
`;

const Info = styled(Typography)`
  &.MuiTypography-root {
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
    color: #a0a0a0;
    font-family: "Open Sans", sans-serif;

    &.underline {
      text-decoration: underline;
    }

    .underline {
      text-decoration: underline;
    }
  }
`;

const TabContent = (props) => {
  const { tabInfo } = props;

  return (
    <>
      {Object.keys(tabInfo).map((tabItemKey, index) => (
        <Row
          display="flex"
          justifyContent="space-between"
          width="100%"
          key={index}
          index={index}
          py="8px"
          px="26px">
          <Label>{tabItemKey}</Label>
          <Info className={tabInfo[tabItemKey].underline ? 'underline' : ''}>{tabInfo[tabItemKey].value}</Info>
        </Row>
      ))}
    </>);
};

export default TabContent;